import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { BaseApiTemplateService, BasicApiResponseModel, Core2Config, ApiVisa } from '../../shared';
import { ApiResponseModel } from '../../shared/api-response.model';
import { GenericDocumentCloneDTO } from '../../../data-transfer-objects';
import { CashDocumentContainerModel } from '../../../../../../../lib/models/aggregates/index';


@Injectable({
  providedIn: 'root'
})
export class CashTransferService extends BaseApiTemplateService<any> {

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/cash-transfers/backoffice-ep";
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/cash-transfers/backoffice-ep";
        this.httpClient = http;
      }

      public updatePostingStatus(dtoObject: any, apiVisa: ApiVisa, guid: string) {
        let apiUrl = apiVisa.api_domain_url +Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/cash-transfers/update-posting-status/" + guid
        return this.httpClient.put<ApiResponseModel<any>>(
          apiUrl,
          dtoObject,
          this.getHttpHeader(apiVisa)
        );
      }

      public createTemp(payload: any, apiVisa: ApiVisa) {
        let apiUrl = apiVisa.api_domain_url +Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "fi/cash-transfers/temp/backoffice-ep"
        return this.httpClient.post<ApiResponseModel<any>>(
          apiUrl,
          payload,
          this.getHttpHeader(apiVisa)
        );
      }
    
      public cloneDocument(guid: string, visa: ApiVisa) {
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path + "/clone/" + guid;
        }
        return this.httpClient.post<BasicApiResponseModel<CashDocumentContainerModel>>(
          this.apiUrl, this.getHttpHeader(visa)
        );
      }
}